/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Dropdown, Row } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { RootState } from 'store';
import TimerDropdown from 'components/Timer/TimerDropdown';
import styles from './TasksDropdown.module.less';

interface TasksDropdownProps {
  onEmpty?: any;
  iconSize?: 'sm' | 'md' | 'lg';
}

const iconSizeValues = {
  sm: 12,
  md: 14,
  lg: 16,
};

const TasksDropdown: FC<TasksDropdownProps> = ({ onEmpty, iconSize = 'md' }) => {
  const { data, loading } = useSelector((store: RootState) => store.activeLogs);
  const runningLogs = data?.filter((el: any) => el.status === 'running' && data?.length > 1);

  useEffect(() => {
    if (!onEmpty) return;

    if (!(data && data?.length > 0)) {
      onEmpty(true);
    } else {
      onEmpty(false);
    }
  }, [data]);

  if (!(data && data?.length > 0)) {
    return null;
  }

  return (
    <Dropdown
      trigger={[isMobile ? 'click' : 'hover']}
      placement="bottomRight"
      overlay={
        <div className={styles.dropdown}>
          <div className={`${styles.wrapper} ${loading ? styles.loading : ''}`} onClick={(event) => event.stopPropagation()}>
            {runningLogs && runningLogs.length > 0 && (
              <div className={styles.head}>
                {runningLogs.map((el: any) =>
                  el.status !== 'running' ? null : (
                    <Row className={styles.item} justify="space-between" key={el.uuid}>
                      <Link className={styles.title} to={`?task_uuid=${el.source === 'task' ? el.source_uuid : ''}`}>
                        {el.source_title}
                      </Link>

                      <TimerDropdown timerContent={el} insideTasksDropdown />
                    </Row>
                  ),
                )}
              </div>
            )}
            <div className={styles.body} onClick={(event) => event.stopPropagation()}>
              {data?.map((el: any) =>
                el.status === 'running' && data?.length > 1 ? null : (
                  <Row className={styles.item} justify="space-between" key={el.uuid}>
                    <Link className={styles.title} to={`?task_uuid=${el.source === 'task' ? el.source_uuid : ''}`}>
                      {el.source_title}
                    </Link>
                    <TimerDropdown timerContent={el} insideTasksDropdown />
                  </Row>
                ),
              )}
            </div>
          </div>
        </div>
      }
    >
      <DownOutlined style={{ fontSize: iconSizeValues[iconSize], cursor: 'pointer' }} />
    </Dropdown>
  );
};

export default TasksDropdown;
